export default __webpack_public_path__ + "static/media/PrivacyPolicy.05344f23.md";